import { render, staticRenderFns } from "./PayStatus.vue?vue&type=template&id=72a3d548&scoped=true&lang=html"
import script from "./PayStatus.vue?vue&type=script&lang=js"
export * from "./PayStatus.vue?vue&type=script&lang=js"
import style0 from "./PayStatus.vue?vue&type=style&index=0&id=72a3d548&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3d548",
  null
  
)

export default component.exports